@if(isLoading)
{
<div class="d-flex flex-column align-items-center justify-content-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser data</h4>
</div>
}
@else if(errorMessage)
{
<div class="d-flex flex-column align-items-center justify-content-center w-100 vh-80 text-center">
    <i class="fa-regular fa-lock fa-3x text-danger mb-3"></i>
    <h4 class="mb-2">Ingen adgang</h4>
    <p class="text-muted mb-4">{{ errorMessage }}</p>
    <div class="d-flex">
        <button class="btn btn-outline-secondary" (click)="navigateToList()">
            <i class="fa-regular fa-arrow-left me-1"></i> Gå tilbage
        </button>
        <button class="btn btn-primary" (click)="reloadPage()">
            <i class="fa-regular fa-arrows-rotate me-1"></i> Prøv igen
        </button>
    </div>
</div>
}
@else
{
<div class="card d-flex flex-column mt-4" style="height: calc(100vh - 120px);">
    <div class="card-header d-flex justify-content-between align-items-center flex-shrink-0">
        <div class="fw-bold">
            Synkroniseringskontrakt for kunde: {{ synchronization.customerName }}
            [{{ synchronization.customerId }}] - Regnskab: {{ synchronization.companyName }} [{{
            synchronization.companyId }}] {{ synchronization.activated == null ? '(inaktiv)' : '' }}
        </div>
        <div class="d-flex align-items-center gap-2">
            @if(synchronization.activated != null)
            {
            <!-- Active toggle next to Opdater button -->
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="check1" (click)="onDisable()"
                    [(ngModel)]="synchronization.enabled">
                <label class="form-check-label" for="check1">Aktiv</label>
            </div>
            <button class="btn btn-primary" (click)="onUpdateSyncronization()">Opdater</button>
            @if (isAdminUser && synchronization.enabled)
            {
            <button class="btn btn-warning" ngbTooltip="Hent synkroniseringskontrakt (authfile)"
                (click)="downloadSyncContract($event)"><i class="fa-download fa-regular"></i></button>
            }
            }
            @if(synchronization.enabled == false)
            {
            <button class="btn btn-danger" ngbTooltip="Slet synkroniseringskontrakt" (click)="deleteSync()"><i
                    class="fa-regular fa-trash-can"></i></button>
            }
        </div>
    </div>
    <!-- Textfields section -->
    <div class="card-header flex-shrink-0">
        <div class="row">
            <div class="col-8">
                <!-- Name field - always visible -->
                <div class="d-flex align-items-center justify-content-between mt-1 mb-2">
                    <div class="d-flex align-items-center flex-grow-1 me-3">
                        <div class="input-group flex-grow-1">
                            <span class="input-group-text" style="min-width: 125px;">Navn:</span>
                            @if (synchronization.activated != null) {
                            <input type="text" class="form-control" id="synchronization-name"
                                [(ngModel)]="synchronization.name">
                            } @else {
                            <span class="form-control">{{ synchronization.name || '(ingen navn)' }}</span>
                            }
                        </div>
                    </div>
                    <!-- Show expand button always -->
                    <div class="d-flex align-items-center flex-shrink-0">
                        <label class="me-2">Vis aktiverings nøgler</label>
                        <button class="btn btn-link p-0 text-secondary"
                            (click)="showDetailsExpanded = !showDetailsExpanded"
                            ngbTooltip="{{ showDetailsExpanded ? 'Skjul' : 'Vis' }}">
                            <i class="fas fa-angles-down"
                                [style.transform]="showDetailsExpanded ? 'rotate(180deg)' : 'rotate(0deg)'"
                                style="transition: transform 0.2s ease;"></i>
                        </button>
                    </div>
                </div>

                <!-- Activation key row - only visible when NOT activated AND expanded -->
                @if (synchronization.activated == null && showDetailsExpanded) {
                <div class="d-flex align-items-center mt-2 mb-2">
                    <div class="input-group flex-grow-1">
                        <span class="input-group-text" style="min-width: 125px;">Aktiveringsnøgle:</span>
                        <input type="text" class="form-control" id="activation-key" [value]="synchronization.key"
                            readonly>
                        <button class="btn btn-primary" ngbTooltip="Kopier aktiveringsnøgle til clipboard."
                            container="body" (click)="copyApiKey()"><i class="fa-clipboard fa-regular"></i></button>
                        <button class="btn btn-primary" ngbTooltip="Refresh aktiveringsnøgle" container="body"
                            (click)="refreshActivationKey()"><i class="fa-arrow-rotate-right fa-regular"></i></button>
                        @if(showActivateSync) {
                        <button class="btn btn-warning" ngbTooltip="Aktiver synkronisering" container="body"
                            (click)="activateSync()"><i class="fa-group-arrows-rotate fa-regular"></i></button>
                        }
                    </div>
                </div>
                }

                <!-- API key and external key - only visible when activated AND expanded -->
                @if (synchronization.activated != null && showDetailsExpanded) {
                <div class="d-flex align-items-center mt-2">
                    <div class="input-group flex-grow-1">
                        <span class="input-group-text" style="min-width: 125px;">Api nøgle:</span>
                        <input type="text" class="form-control" id="api-key" [value]="synchronization.key" readonly>
                        <button class="btn btn-primary" ngbTooltip="Kopier api nøgle til clipboard." container="body"
                            (click)="copyApiKey()"><i class="fa-clipboard fa-regular"></i></button>
                    </div>
                </div>
                @if (isAdminUser) {
                <div class="d-flex align-items-center mt-2">
                    <div class="input-group flex-grow-1">
                        <span class="input-group-text" style="min-width: 125px;">Ekstern nøgle:</span>
                        <input type="text" class="form-control" id="external-key" [value]="externalkey" readonly>
                        <button class="btn btn-primary" ngbTooltip="Vis/skjul nøgle i klar tekst" container="body"
                            (click)="toggleKey()"><i
                                [class]="showExternalKeyInClearText ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i></button>
                        <button class="btn btn-primary" ngbTooltip="Kopier eksternnøgle til clipboard." container="body"
                            (click)="copyExternalKey()"><i class="fa-clipboard fa-regular"></i></button>
                    </div>
                </div>
                }
                }
            </div>
            <!-- Right side - Status check info (only when NOT activated) -->
            <div class="col-4">
                @if (synchronization.activated == null) {
                <div class="mt-3 small">
                    <!-- Always visible explanatory text -->
                    <div class="text-muted fst-italic mb-2">
                        Vil automatisk opdatere når synkronisering er aktiveret
                    </div>

                    <!-- Activation key countdown timer (hidden but not unloaded when collapsed) -->
                    <div [hidden]="!showDetailsExpanded" style="max-width: 400px;">
                        <app-countdown-timer #countdownTimer [totalMilliseconds]="refreshKeyTime"
                            [warnThresholdPercent]="20" [dangerThresholdPercent]="10"
                            [label]="'Aktiveringsnøgle udløber om:'" [expiredLabel]="'Aktiveringsnøgle udløbet!'" />
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="d-flex flex-column card-body no-padding flex-grow-1" style="min-height: 0;">
        @if (synchronization.activated != null) {
        <!-- Same component the Overvågning page renders, scoped to this one synchronization — so
             filtering for it there and opening it here are the same view, not two that resemble
             each other. The height comes from this card body's flex chain; the browser measures
             nothing of its own. -->
        <app-queue-request-browser [customerId]="synchronization.customerId"
            [synchronizationId]="synchronization.id" />
        } @else {
        <!-- Not a load, so not a skeleton: there is nothing to wait for until the synchronization is
             activated. -->
        <div class="card-body text-center text-secondary py-5">
            Synkroniseringen er ikke aktiveret endnu. Kørsler vises her, når den er aktiveret.
        </div>
        }
    </div>
</div>
}